export const FORM_CONTROL_NUMBER_PATTERN = /^[0-9]+$/;
